import { Injector } from "@angular/core";
import { environment } from "../../../../../environments/environment";
import { QueryResultNode } from "../QueryResultNode";
import { MeddraService } from "../../../service/meddra-service/meddra.service";
import { Art57Section } from "../../Art57Section/Art57Section";
import { QueryFieldsNode } from "../QueryFieldsNode";
import { QueryConditionsNode } from "../QueryConditionsNode";

export class MeddraQueryResultNode extends QueryResultNode {
    fieldsToRetrieve: string = '';
    constructor(injector: Injector, data: any, labelTemplate: string, entityName: string, fieldsToRetrieve: string, fieldsNode: QueryFieldsNode, conditionsNode: QueryConditionsNode, ) {
        super(injector, data, labelTemplate, entityName, fieldsNode, conditionsNode, []);
        this.fieldsToRetrieve = fieldsToRetrieve;
    }

    exportToExcel() {
        this.ioc!.get(Art57Section).showTooltipMessage({ severity: 'success', detail: 'Exporting records to Excel file...', life: environment.successElapsedTime });

        
        this.ioc!.get(MeddraService).exportResultsToExcel(this.entityName, this.data.model, this.fieldsToRetrieve)
          .subscribe({
            next: (response: any) => {
              const contentDisposition = response.headers.get('content-disposition');
              const filename = contentDisposition.match(/filename=(.+)$/)[1].replace(/['"]/, '').trim();
              const url = window.URL.createObjectURL(response.body as Blob);
              const a = document.createElement('a');
              a.href = url;
              a.download = filename;
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
              window.URL.revokeObjectURL(url);
              this.ioc!.get(Art57Section).showTooltipMessage({ severity: 'success', detail: 'Exporting records to Excel finished', life: environment.successElapsedTime });
            },
            error: (error: any) => {
              this.ioc!.get(Art57Section).showTooltipMessage({
                severity: 'error',
                detail: 'Error found',
                life: environment.errorElapsedTime,
              });
            },
          });
    }




    getDate(): string {
        const date = new Date();

        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        const hour = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        const seconds = date.getSeconds().toString().padStart(2, '0');

        return `${year}-${month}-${day}+${hour}.${minutes}.${seconds}`;
    }

}